import { getJson, handleResult } from '../http';
import confirmDialog from '../dialogs/confirm-dialog';

// Application/Index: archive and restore. Rows hold `active` (true while not archived) and ask with:
//   $dispatch('application-request', { jobId, applicantId, name, row: $data })
export const applicationDialog = () => ({
  ...confirmDialog(),

  ask({ jobId, applicantId, name, row }) {
    const archive = row.active;

    this.show({
      title: `${archive ? 'Archive' : 'Restore'} this application?`,
      name,
      message: archive ? 'will be archived.' : 'will be restored.',
      confirmLabel: archive ? 'Archive' : 'Restore',
      tone: archive ? 'danger' : 'primary',
      action: async () => {
        const response = await getJson(`/application/${archive ? 'archive' : 'restore'}`, { jobId, applicantId });
        handleResult(response, () => {
          row.active = !archive;
        });
      },
    });
  },
});
